module.exports = __webpack_public_path__ + "assets/images/7-p8nRU4h.jpg";